import * as React from 'react'
import { useIntl } from 'react-intl'

import PriceDetails from 'tripPlanner/components/ItemOfferPrice/PriceDetails'
import BodyText from 'LuxKit/Typography/BodyText'
import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import { rem } from 'polished'
import styled from 'styled-components'

interface Props {
  /** If null, don't show price */
  price?: number
  luxPlusPrice?: number
  value?: number
  currencyCode: string
  priceLabel?: string
  isOfferAvailable: boolean
  discountPercent?: number
  discountDisplayType?: React.ComponentProps<
    typeof PriceDetails
  >['discountDisplayType']
  totalLabel?: string
}

const SoldOutText = styled(BodyText)`
  padding-bottom: ${rem(4)};
`

export function PlannedItemPriceContent(props: Props) {
  const intl = useIntl()
  const {
    price,
    luxPlusPrice,
    value,
    priceLabel = 'From',
    discountPercent,
    currencyCode,
    isOfferAvailable,
    discountDisplayType,
    totalLabel,
  } = props

  const showPrice = typeof price === 'number'

  const shouldShowDiscountPercent =
    !!discountPercent &&
    discountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE

  if (!isOfferAvailable) {
    return (
      <SoldOutText variant="large" weight="bold">
        {intl.formatMessage({
          id: '29e0qhZXs7zNQFR4mmIV',
          defaultMessage: 'Sold Out',
          description: 'Status label shown when a planned trip item offer is no longer available',
        })}
      </SoldOutText>
    )
  }

  if (!showPrice) {
    return null
  }

  return (
    <PriceDetails
      price={Math.ceil(price)}
      luxPlusPrice={luxPlusPrice ? Math.ceil(luxPlusPrice) : undefined}
      value={value ? Math.ceil(value) : undefined}
      currencyCode={currencyCode}
      discount={
        shouldShowDiscountPercent ? Math.floor(discountPercent) : undefined
      }
      priceLabel={priceLabel}
      discountDisplayType={discountDisplayType ?? 'following'}
      totalLabel={totalLabel}
      showTaxesAndFees={false}
    />
  )
}
